if (!('fromEntries' in Object)) {
  import('core-js/features/object/from-entries');
}

export {};
